export { default } from './product-advertence';
